export var PARTNER_CART_STATE_KEY = '@partnerCart';
export var PARTNER_CART_INITIAL_STATE = {
  inFlight: false,
  errors: []
};
export var GET_PREORDER_CALLED = "".concat(PARTNER_CART_STATE_KEY, "/GET_PREORDER_CALLED");
export var GET_PREORDER_FAILURE = "".concat(PARTNER_CART_STATE_KEY, "/GET_PREORDER_FAILURE");
export var GET_PREORDER_ABORT = "".concat(PARTNER_CART_STATE_KEY, "/GET_PREORDER_ABORT");
export var GET_PREORDER_SUCCESS = "".concat(PARTNER_CART_STATE_KEY, "/GET_PREORDER_SUCCESS");
export var CLEAR_PARTNER_CART_ERRORS = "".concat(PARTNER_CART_STATE_KEY, "/CLEAR_PARTNER_CART_ERRORS");
export var STATUS_TYPE_PENDING = 'PENDING';
export var STATUS_TYPE_IN_PROGRESS = 'IN_PROGRESS';